export const getTranslateKey = value => {
  return value ? String(value)?.toLowerCase()?.split(" ").join("-") : "";
};